import { getContext } from '@fiverr-private/fiverr_context';

export const shouldDisplayBusinessFilter = () => {
    const { isMobile } = getContext();

    return !isMobile && (isLoggedOutBusinessUser() || isBusinessUser());
};

export const isBusinessUser = () => {
    const { organizationId } = getContext();

    return !!organizationId;
};

export const isLoggedOutBusinessUser = () => isBusinessDomain() && !isUserLogged();

export const isUserLogged = () => {
    const { userId } = getContext();

    return !!userId;
};

export const isBusinessDomain = () => {
    const { experience } = getContext();

    return experience && experience.isBusiness;
};
